import { createContext, useContext } from "react";
import pl from "@/i18n/pl.json";
import en from "@/i18n/en.json";

export const SITE_URL = "https://onkolife.pl";
export const LANGS = ["en", "pl"];
const DICTS = { en, pl };

export const ROUTES = {
  home: { en: "/", pl: "/pl/" },
  about: { en: "/about/", pl: "/pl/o-mnie/" },
  philosophy: { en: "/treatment-philosophy/", pl: "/pl/filozofia-leczenia/" },
  cases: { en: "/clinical-cases/", pl: "/pl/przypadki-kliniczne/" },
  publications: { en: "/publications/", pl: "/pl/publikacje/" },
  interviews: { en: "/interviews/", pl: "/pl/wywiady/" },
  contact: { en: "/contact/", pl: "/pl/kontakt/" },
};
export const NAV_KEYS = ["about", "philosophy", "cases", "publications", "interviews", "contact"];

const LangContext = createContext("en");
export const LangProvider = LangContext.Provider;

export const useLang = () => {
  const lang = useContext(LangContext);
  return { lang, t: DICTS[lang], to: (key) => ROUTES[key][lang], other: lang === "en" ? "pl" : "en" };
};
